export const getMenuTokens = (tokens) => {
    return {
        menu: tokens.component.menu,
        semantic: tokens.semantic,
    };
};
export const getSharedMenuItemStyles = (tokens) => {
    const { menu } = getMenuTokens(tokens);
    return {
        backgroundColor: "transparent",
        height: menu.item.height.value,
        gap: menu.item.gap.value,
        fontWeight: menu.item.fontWeight.value,
        fontSize: menu.item.fontSize.value,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: menu.item.paddingHorizontal.value,
        paddingRight: menu.item.paddingHorizontal.value,
        color: menu.item.color.value,
    };
};
const menu = (tokens) => {
    const { menu, semantic } = getMenuTokens(tokens);
    const sharedMenuItemStyles = getSharedMenuItemStyles(tokens);
    return {
        MuiMenu: {
            defaultProps: {
                elevation: 6,
            },
            styleOverrides: {
                root: {
                    "& .MuiPaper-root": {
                        backgroundColor: menu.backgroundColor.value,
                        borderRadius: menu.borderRadius.value,
                    },
                    "& .MuiMenu-list": {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, sharedMenuItemStyles), { "& .MuiListItemText-root, .MuiListItemIcon-root svg": {
                        color: menu.item.color.value,
                    } }), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "destructive" && {
                    color: menu.item.destructive.color.value,
                    "& .MuiListItemText-root, .MuiListItemIcon-root svg": {
                        color: menu.item.destructive.color.value,
                    },
                })), { "&:hover": {
                        backgroundColor: menu.item.hover.backgroundColor.value,
                    }, "&:active": {
                        backgroundColor: menu.item.active.backgroundColor.value,
                    }, "&:focus, &.Mui-focusVisible": {
                        boxShadow: semantic.shadow.focusInset.value.stringValue,
                    }, ".MuiListItemIcon-root": {
                        minWidth: "initial",
                    }, "&+.MuiDivider-root": {
                        marginTop: 0,
                        marginBottom: 0,
                    }, "&:first-of-type": {
                        borderTopLeftRadius: menu.borderRadius.value,
                        borderTopRightRadius: menu.borderRadius.value,
                    }, "&:last-child": {
                        borderBottomLeftRadius: menu.borderRadius.value,
                        borderBottomRightRadius: menu.borderRadius.value,
                    }, ".MuiCheckbox-root": {
                        height: "100%",
                    }, "&.Mui-selected": {
                        backgroundColor: menu.item.selected.backgroundColor.value,
                    } })),
            },
        },
    };
};
export default menu;
//# sourceMappingURL=menu.js.map